import { motion, useReducedMotion } from 'motion/react';

const DIGITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
const TILE = 'h-[101px] w-[74px]';
/** Figma always shows three tiles, even at zero. A bigger number simply grows more of them. */
const MIN_TILES = 3;

/**
 * One tile: a column of 0–9 sliding behind an orange card. The column is exactly ten tiles tall, so
 * `-value * 10%` lands the wanted digit dead centre; the spring rolls through the digits in between.
 */
function DigitTile(props: { value: number; reduce: boolean }) {
	return (
		<div className={`bg-brand relative overflow-hidden rounded-lg ${TILE}`}>
			<motion.div
				className="absolute inset-x-0 top-0"
				animate={{ y: `${-props.value * 10}%` }}
				transition={props.reduce ? { duration: 0 } : { type: 'spring', stiffness: 120, damping: 18 }}
			>
				{DIGITS.map((d) => (
					<div
						key={d}
						className={`flex items-center justify-center text-[4.5rem] leading-none font-medium tracking-[-0.02em] text-black tabular-nums ${TILE}`}
					>
						{d}
					</div>
				))}
			</motion.div>
		</div>
	);
}

/**
 * The rolling counter of the Solutions hero. Presentational only — it renders whatever `count` it is
 * given. Screen readers get the plain number; the tiles are just the animation of it.
 */
export function DonationOdometer(props: { count: number }) {
	const reduce = useReducedMotion() ?? false;
	const digits = String(props.count).padStart(MIN_TILES, '0').split('').map(Number);

	return (
		<div className="flex shrink-0 gap-2" role="status" aria-live="polite" aria-atomic>
			<span className="sr-only">{props.count}</span>
			{digits.map((d, i) => (
				// oxlint-disable-next-line react/no-array-index-key
				<DigitTile key={i} value={d} reduce={reduce} />
			))}
		</div>
	);
}
